import { render, staticRenderFns } from "./UnloadAffirm.vue?vue&type=template&id=c2eb36f6&scoped=true"
import script from "./UnloadAffirm.vue?vue&type=script&lang=js"
export * from "./UnloadAffirm.vue?vue&type=script&lang=js"
import style0 from "./UnloadAffirm.vue?vue&type=style&index=0&id=c2eb36f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2eb36f6",
  null
  
)

export default component.exports